import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

/**
 * HTMLサンプル
 * 
<div class="splide" id="hero" role="group" aria-label="〇〇のスライダー">
    <div class="splide__track">
        <ul class="splide__list">
            <li class="splide__slide"><img src="a.jpg" alt="" /></li>
            <li class="splide__slide"><img src="b.jpg" alt="" /></li>
            <li class="splide__slide"><img src="c.jpg" alt="" /></li>
        </ul>
    </div>
</div>

 * 
 */

// function slider() {
//   //必要なもののみアクティブにしてください
//   const options = {
//     type: 'loop',
//     perPage: 3,
//     perMove: 1,
//     gap: '16px',
//     padding: '1rem',
//     arrows: true,
//     pagination: true,
//     drag: true,
//     snap: true,
//     speed: 500,
//     easing: 'ease',
//     autoplay: true,
//     interval: 3000,
//     pauseOnHover: false,
//     pauseOnFocus: true,
//     lazyLoad: 'nearby',
//     preloadPages: 2,
//     rewind: true,
//     focus: 'center',
//     updateOnMove: true,
//     breakpoints: {
//       640: {
//         perPage: 1,
//         gap: '8px',
//         padding: '0.25rem',
//       },
//       1024: {
//         perPage: 2,
//         gap: '12px',
//         padding: '0.5rem',
//       },
//     },
//     reducedMotion: {
//       speed: 0,
//       rewindSpeed: 0,
//       autoplay: 'pause',
//     },
//   };

//   const splide = new Splide('.splide.p-index-case', options);
//   splide.mount();
// }

// ============================================
// top case
// ============================================

function slider() {
  const slide = document.querySelector('.js-slide-case');
  if (!slide) return;

  const option = {
    type: 'loop',
    speed: 1000,
    autoplay: true,
    arrows: true,
    pagination: true,
    gap: 40,
    pauseOnHover: true,
    padding: {
      left: '1%', // 左の余白を0にする
      right: '60%', // 必要なら右側に次の画像を見せる余白
    },
    updateOnMove: true,
    breakpoints: {
      768: {
        padding: {
          left: '1%', // 左の余白を0にする
          right: '7%', // 必要なら右側に次の画像を見せる余白
        },
        gap: 16,
      },
    },
  };

  const splide = new Splide(slide, option);

  splide.mount();
}
export { slider };
